import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { HomeComponent } from './public/home/home.component';
import { AuthGaurdService } from './admin/auth-gaurd.service';
import { BlogDetailsComponent } from './public/blog/blog-details/blog-details.component';
import { PublicLayoutComponent } from './public/public-layout/public-layout.component';
import { ArticleDetailsComponent } from './public/article/article-details/article-details.component';
import { ArticleListComponent } from './public/article/article-list/article-list.component';
import { ProjectDetailsComponent } from './public/project/project-details/project-details.component';
import { ProjectListComponent } from './public/project/project-list/project-list.component';
import { BookListComponent } from './public/book/book-list/book-list.component';
import { BookDetailsComponent } from './public/book/book-details/book-details.component';
import { BlogListComponent } from './public/blog/blog-list/blog-list.component';
import { EventDetailsComponent } from './public/event/event-details/event-details.component';
import { EventListComponent } from './public/event/event-list/event-list.component';
import { AboutDetailsComponent } from './public/about/about-details/about-details.component';
import { MultimediasComponent } from './public/multimedias/multimedias.component';
import { ErrorPageComponent } from './public/error-page/error-page.component';
import { BiographyDetailsComponent } from './public/biography/biography-details/biography-details.component';
import { BiographyListComponent } from './public/biography/biography-list/biography-list.component';
import { NewsPaperDetailsComponent } from './public/news-paper/news-paper-details/news-paper-details.component';
import { NewsPaperListComponent } from './public/news-paper/news-paper-list/news-paper-list.component';
import { MenuscriptDetailsComponent } from './public/menuscript/menuscript-details/menuscript-details.component';
import { MenuscriptListComponent } from './public/menuscript/menuscript-list/menuscript-list.component';
import { ContactPageComponent } from './public/contact-page/contact-page.component';

export const routes: Routes = [
    

    {
        path: 'admin',
        canActivate:[AuthGaurdService],
        loadChildren: () => import('./admin/admin-routing.module').then(m => m.AdminRoutingModule)
    },
    {
        path: '', component: PublicLayoutComponent,
        children: [
            {path: 'login', component: LoginPageComponent},
            { path: "articles/:type/list", component: ArticleListComponent },   
            { path: "articles/:id", component: ArticleDetailsComponent },  
            { path: "articles", component: ArticleListComponent }, 
            
            { path: "projects/:type/list", component: ProjectListComponent },   
            { path: "projects/:id", component: ProjectDetailsComponent },  
            { path: "projects", component: ProjectListComponent }, 

            { path: "books/:category/list", component:  BookListComponent },   
            { path: "books/:id", component: BookDetailsComponent },  
            { path: "books", component: BookListComponent }, 

            { path: "blogs/:id", component: BlogDetailsComponent },  
            { path: "blogs", component: BlogListComponent }, 

            { path: "events/:id", component: EventDetailsComponent },  
            { path: "events", component: EventListComponent }, 


            { path: "abouts", component: AboutDetailsComponent }, 

            { path: "multimedia", component: MultimediasComponent }, 

            { path: "biographies/:id", component: BiographyDetailsComponent },  
            { path: "biographies", component: BiographyListComponent }, 

            { path: "news-papers/:id", component: NewsPaperDetailsComponent },  
            { path: "news-papers", component: NewsPaperListComponent },

            { path: "menuscripts/:id", component: MenuscriptDetailsComponent },  
            { path: "menuscripts", component: MenuscriptListComponent },

            { path: "contact", component: ContactPageComponent },

            { path: "", component: HomeComponent }
        ]
    },
    
    {path: '', component: HomeComponent},

    { path: '**', component: ErrorPageComponent } // This line will remain down from the whole pages component list

];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule]
})
export class AppRoutingModule { }